<template>
<div class="chapter">
<div class="inner_page">
<p class="cip-break"><a id="pIV"></a>Published with assistance from the foundation established in memory of <br/>Calvin Chapin of the class of 1788, Yale College.</p>
<p class="linespace"></p>
<p class="cip">Copyright © 2017 by Mary Graham. All rights reserved.</p>
<p class="cip">This book may not be reproduced, in whole or in part, including illustrations, <br/>in any form (beyond that copying permitted by Sections 107 and 108 of the <br/>U.S. Copyright Law and except by reviewers for the public press), <br/>without written permission from the publishers.</p>
<p class="linespace"></p>
<p class="cip">Yale University Press books may be purchased in quantity for educational, <br/>business, or promotional use. For information, please e-mail <a href="mailto:sales.press@yale.edu">sales.press@yale.edu</a> <br/>(U.S. office) or <a href="mailto:sales@yaleup.co.uk">sales@yaleup.co.uk</a> (U.K. office).</p>
<p class="linespace"></p>
<p class="cip">Set in Time Roman type by IDS Infotech Ltd., Chandigarh, India.</p>
<p class="cip">Printed in the United States of America.</p>
<p class="linespace"></p>
<p class="cip">ISBN 978-0-300-22374-3</p>
<p class="cip">Library of Congress Control Number 2016950309</p>
<p class="cip">A catalogue record for this book is available from the British Library.</p>
<p class="linespace"></p>
<p class="cip">This paper meets the requirements of ANSI/NISO Z39.48-1992 <br/>(Permanence of Paper).</p>
<p class="linespace"></p>
<p class="cip">10  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?1aa61e8e